/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.deviceGroup', [])
    .factory('deviceGroupService', DeviceGroupService)
    .name;

/*@ngInject*/
function DeviceGroupService($http, $q) {

    var service = {
        deleteDeviceGroup: deleteDeviceGroup,
        getDeviceGroup: getDeviceGroup,
        getSystemDeviceGroup: getSystemDeviceGroup,
        saveDeviceGroup: saveDeviceGroup,
        getCustomerDeviceGroups: getCustomerDeviceGroups,
        getSubCustomerDeviceGroups: getSubCustomerDeviceGroups,
        assignDeviceGroupToSubCustomer: assignDeviceGroupToSubCustomer,
        unassignDeviceGroupFromSubCustomer: unassignDeviceGroupFromSubCustomer,
        saveAlarmRules: saveAlarmRules
    };

    return service;

    function getCustomerDeviceGroups () {
        var deferred = $q.defer();
        $http.get('/api/customer/applications', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSubCustomerDeviceGroups (subCustomerId) {
        var deferred = $q.defer();
        $http.get(`/api/subCustomer/${subCustomerId}/applications`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getDeviceGroup (applicationId) {
        var deferred = $q.defer();
        var url = '/api/application/' + applicationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSystemDeviceGroup (applicationId) {
        var deferred = $q.defer();
        var url = '/api/system/application/' + applicationId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveAlarmRules (applicationId, alarmRules) {
        var deferred = $q.defer();
        var url = `/api/application/${applicationId}/alarmRules`;
        $http.post(url, alarmRules).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveDeviceGroup (deviceGroup) {
        var deferred = $q.defer();
        var url = '/api/application';
        $http.post(url, deviceGroup).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteDeviceGroup (applicationId) {
        var deferred = $q.defer();
        var url = '/api/application/' + applicationId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function assignDeviceGroupToSubCustomer(subCustomerId, applicationId) {
        var deferred = $q.defer();
        var url = `/api/subCustomer/${subCustomerId}/application/${applicationId}`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function unassignDeviceGroupFromSubCustomer(applicationId) {
        var deferred = $q.defer();
        var url = `/api/subCustomer/application/${applicationId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/device-group.service.js